module.exports = __webpack_public_path__ + "img/fu7.52d1eb9c.png";